<template>
  <FormViewBase title="Reset Password">
    <template #header>
      <v-btn
        exact
        outlined
        color="blue darken-2"
        :block="$mq | mq({ xs: true, md: false })"
        :to="{ name: CustomerLoginRoute }"
        class="mb-4"
        ><v-icon small left>mdi-arrow-left</v-icon>Back to Login</v-btn
      >
    </template>
    <template #default>
      <div class="text-h6"
        >If your email is in our system, we'll send a you a message with a reset
        link.</div
      >
      <EmailField
        ref="email"
        label="Your Email"
        :value="email"
        @input="email = $event"
        data-lpignore="true"
        autocomplete="new-password"
        class="my-2"
      />
    </template>
    <template #errors>
      <v-alert v-if="!!error" type="warning" text>
        {{ error }}
      </v-alert>
    </template>
    <template #actions="{ valid }">
      <SendPasswordResetButton
        :email="email"
        title="Send reset email"
        :disabled="!email || !valid"
        color="orange darken-3"
        :text="false"
        @error="error = $event"
        large
        depressed
      />
    </template>
  </FormViewBase>
</template>

<script>
import { mapFields } from 'vuex-map-fields'
import { mapActions } from 'vuex'
import FormViewBase from '@/views/FormViewBase'
import EmailField from '@/components/EmailField'
import RouteNames from '@/constants/RouteNames'
import SendPasswordResetButton from '@/components/SendPasswordResetButton'

import _get from 'lodash/get'
export default {
  name: 'ForgotPasswordView',
  components: {
    FormViewBase,
    EmailField,
    SendPasswordResetButton,
  },
  props: {
    token: {
      type: String,
      require: true,
    },
  },
  data() {
    return {
      email: '',
      newPass: '',
      error: null,
      success: true,
      CustomerLoginRoute: RouteNames.Customer.LOGIN,
    }
  },
  computed: {
    ...mapFields('snackbars', ['showPasswordUpdatedSnackbar']),
  },
  methods: {
    ...mapActions('auth', ['resetPassword']),
    async updatePassword() {
      let { email, newPass: password, token } = this
      this.success = false
      this.$emit('sending')
      try {
        let { data: res } = await this.resetPassword({ email, password, token })
        this.success = true
        this.showPasswordUpdatedSnackbar = true
        let redirectPathName = RouteNames.Guest.HOME
        if (res.data.is_merchant) {
          redirectPathName = RouteNames.Merchant.LOGIN
        } else {
          redirectPathName = RouteNames.Customer.LOGIN
        }
        this.$router.push({ name: redirectPathName })
      } catch (error) {
        this.error = _get(
          error,
          'response.data.error.message',
          'Your password could not be reset.'
        )
      } finally {
        this.$emit('done')
      }
    }, // updatePassword
  },
}
</script>
